import { Component, effect, inject, input, output, signal, ViewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NewEquipmentService } from '../../../services/new-equipment.service';
import { SlickCarouselComponent, SlickCarouselModule } from 'ngx-slick-carousel';
import { CategoryCarousel } from '../../models/new-category.model';
import { CommonModule, NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-new-carousel',
  imports: [CommonModule, NgOptimizedImage, SlickCarouselModule, RouterModule],
  templateUrl: './new-carousel.component.html',
  styleUrl: './new-carousel.component.scss',
})
export class NewCarouselComponent {
  private router = inject(Router);
  private newEquipmentService = inject(NewEquipmentService);

  nextPrev = input<string>();
  countEquipment = output<number>();

  @ViewChild('carouselNewHome')
  carouselNewHome!: SlickCarouselComponent;

  categories = signal<CategoryCarousel[]>([]);

  slideConfig = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 920,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  };

  constructor() {
    this.getCategories();
    effect(() => {
      const action = this.nextPrev();
      if (!action) return;
      if (action === 'prev') {
        this.prev();
      } else {
        this.next();
      }
    });
  }

  getCategories() {
    this.newEquipmentService.getCategoriesCarousel().subscribe({
      next: (result) => {
        this.categories.set(result);
        const count = result.reduce((acc, c) => acc + (c.subcategories?.length ?? 0), 0);
        this.countEquipment.emit(count);
      },
      error: console.error,
    });
  }

  next() {
    this.carouselNewHome?.slickNext();
  }

  prev() {
    this.carouselNewHome?.slickPrev();
  }

  goToLink(category: string, subcategory: string) {
    this.router.navigateByUrl(`/productos/${category}/${subcategory}`);
  }
}
